import styled, { createGlobalStyle } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 100%;
  color: white;

  a {
    text-decoration: none;
  }
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  margin: 0 auto;
  background: #1d62d1;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 3rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  font-weight: 700;

  * {
    color: #fff;
  }

  p {
    font-size: 1.5rem;
    font-weight: 600;
    margin-left: 0.5rem;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }
`;

export const FooterLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  & > div {
    margin-bottom: 0.5rem;
  }

  p {
    /* font-size: 1.5rem; */
  }

  @media (max-width: 768px) {
    align-items: center;
    justify-content: center;
  }
`;

export const Nav = styled.nav`
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

export const NavItem = styled.a`
  color: white;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
  cursor: pointer;

  &:hover {
    color: #f6ae2d;
  }
`;

export const HeroButtons = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const Button = styled.button`
  background: linear-gradient(135deg, #f6ae2d 0%, rgb(249, 199, 107) 100%);
  color: #fff;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 1rem;
  font-weight: 600;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  height: 100%;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(255, 215, 0, 0.3);
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const ButtonSecondary = styled.button`
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 0.75rem 1.5rem;
  border-radius: 1rem;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: white;
    color: #333;
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
`;

export const Hero = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 4rem 2rem;
  width: 100%;
  margin: 0 auto;
  background: linear-gradient(180deg, #1d62d1 0%, #5596e6 100%);

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

export const HeroContent = styled.div`
  max-width: 800px;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    font-size: 1.2rem;
    line-height: 1.6;
    margin-bottom: 2rem;
    opacity: 0.9;

    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }
`;

export const HeroTitle = styled.h1`
  font-size: 3.5rem;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 1.5rem;

  span {
    color: #f6ae2d;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const HeroSubtitle = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const HeroImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
`;

export const WhiteCardSection = styled.section`
  background: #fafafc;
  padding: 5rem 2rem 1rem;
  margin: 0;
  width: 100%;
  color: #333;
`;

export const WhiteCardContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  background: #fff;
  border-radius: 1rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0 1px 2px 0, 0 0 0 1.5px #e5e5e5;
  padding: 3rem 0 4rem;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border: 1px solid #e5e5e5;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background: #fff;
  margin-bottom: 1rem;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
`;

export const WhiteCardTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 3rem;
  color: #090909;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const BrowserWrapper = styled.div`
  background: rgb(237, 238, 239);
  border-radius: 10px;
  padding: 1rem;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  max-width: 800px;
  margin: 0 auto;
  position: relative;

  &::before {
    content: '';
    display: block;
    height: 30px;
    background: #e0e0e0;
    border-radius: 10px 10px 0 0;
    margin: -1rem -1rem 1rem -1rem;
    position: relative;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0.5rem;
    left: 1rem;
    width: 12px;
    height: 12px;
    background: #ff5f57;
    border-radius: 50%;
    box-shadow: 20px 0 0 #ffbd2e, 40px 0 0 #28ca42;
  }

  @media (max-width: 768px) {
    padding: 0.5rem;
    margin: 0 1rem;
    border-radius: 8px;

    &::before {
      height: 20px;
      margin: -0.5rem -0.5rem 0.5rem -0.5rem;
      border-radius: 8px 8px 0 0;
    }

    &::after {
      top: 0.25rem;
      left: 0.5rem;
      width: 8px;
      height: 8px;
      box-shadow: 16px 0 0 #ffbd2e, 32px 0 0 #28ca42;
    }
  }
`;

export const BrowserImage = styled.div`
  width: 100%;
  height: 400px;
  background: #fafafc;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 1.2rem;

  @media (max-width: 768px) {
    height: 200px;
    border-radius: 3px;
    font-size: 1rem;
  }
`;

export const FeaturesSection = styled.section`
  background: #fafafc;
  padding: 2rem 2rem 7rem;
  color: #333;
`;

export const FeaturesSectionTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 3rem;
  color: #090909;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const FeaturesCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const FeatureCard = styled.div`
  background: #fafafc;
  overflow: hidden;
  border-radius: 1rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0 1px 2px 0, 0 0 0 1.5px #e5e5e5;
  transition: transform 0.3s ease;
  position: relative;
  height: 300px;

  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    height: 250px;
  }
`;

export const FeatureVideoBackground = styled.div`
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 1rem;
`;

export const FeatureCardContent = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.95));
  color: white;
  padding: 2rem 1.5rem 1.5rem;
`;

export const FeatureCardTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: white;
`;

export const FeatureCardSubtitle = styled.p`
  font-size: 0.9rem;
  opacity: 0.9;
  line-height: 1.4;
  color: white;
`;

export const WhyUs = styled.section`
  background: linear-gradient(135deg, #1d62d1 0%, #5596e6 100%);
  padding: 5rem 2rem 7rem;
  color: white;
  max-width: 100%;
  margin: 0;
`;

export const WhyUsTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 3rem;
  color: #fff;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FeatureCardOld = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 20px;
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

export const FeatureIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #f6ae2d 0%, rgb(249, 199, 107) 100%);
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  color: #fff;
`;

export const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #fff;
`;

export const FeatureDescription = styled.p`
  line-height: 1.6;
  opacity: 0.9;
`;

export const CTA = styled.section`
  width: 100%;
  background: #fafafc;
  padding: 5rem 2rem;
  text-align: center;
`;

export const CTAContent = styled.div`
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CTATitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #090909;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const CTASubtitle = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  opacity: 0.9;
  color: #6f7380;
`;

export const Footer = styled.footer`
  background: #1d62d1;
  padding: 3rem 2rem 1rem;
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 2fr 3fr;
  gap: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

export const FooterLinks = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;

  h4 {
    color: #fff;
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const FooterLink = styled.a`
  display: block;
  color: white;
  text-decoration: none;
  margin-bottom: 0.5rem;
  opacity: 0.8;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
    color: #f6ae2d;
  }
`;

export const FooterSocial = styled.div`
  max-width: 1200px;
  margin: 2rem auto 0;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  div {
    display: flex;
    gap: 1rem;
  }
`;

export const SocialLink = styled.a`
  color: white;
  text-decoration: none;
  opacity: 0.8;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);

  &:hover {
    opacity: 1;
    color: #f6ae2d;
    background: rgba(255, 255, 255, 0.2);
  }
`;

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    outline: 0;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background: transparent;
    color: #6f7380;
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;

    #root {
      display: flex;

      @media (max-width: 800px) {
        flex-direction: column-reverse;
      }
    }
  }

  html, body, #root {
    height: 100%;
  }

  body, input, button {
    /* font-family: 'Inter', sans-serif; */
    font-family: 'Poppins', sans-serif;
    font-size: 1rem;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }
`;
